// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"525bf120","453":"d05dee37","732":"e66d1765"}[chunkId] + ".chunk.js";
};